export default {
  boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.3)'
};



// WEBPACK FOOTER //
// ./src/styles/common.js